{
  "dropzoneLabel": "Místo pro přetažení",
  "selectPlaceholder": "Vyberte položku",
  "tableResizer": "Změna velikosti",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
